import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { ScoreboardFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel, ParticipantInfo, SpecialChar } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig, SitecoreGameMessagesConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { Observable, map } from 'rxjs';

import { EventDetailsService } from '../event-details.service';

@Component({
    selector: 'ms-prematch-scoreboard',
    templateUrl: 'prematch-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PrematchScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() showLogoColor: boolean;
    @Input() isNewEDPScoreboard = false;
    @HostBinding('class') className = 'prematch';
    @Input() showPreMatchTimer = false;
    date: string;
    rotateImage: boolean[] = [];
    participantInfos: ParticipantInfo[];
    isShowLeagueName = false;
    isDoublesPlayer = false;
    broadcaster$: Observable<string> | undefined;
    readonly isEpcotEnabled = this.epcotConfig.isEnabled;

    constructor(
        private scoreboardFactory: ScoreboardFactory,
        private eventDetailsService: EventDetailsService,
        private sitecoreGameMessage: SitecoreGameMessagesConfig,
        private epcotConfig: EpcotConfig,
    ) {}

    ngOnChanges(): void {
        this.event.participants.forEach((participant, index) => {
            this.rotateImage[index] = index === 1;
        });
        this.date = this.scoreboardFactory.showDate(this.event);
        this.participantInfos = this.eventDetailsService.setParticipantInfos(this.event);
        this.isShowLeagueName = this.event.sport.id === SportConstant.Boxing && this.isNewEDPScoreboard;
        this.isDoublesPlayer = this.event.participants.every((p) => p.name.includes(SpecialChar.Slash));
        this.broadcaster$ = this.sitecoreGameMessage.whenReady.pipe(
            map(() => (this.sitecoreGameMessage.secondaryBroadcastInfo?.messages ?? {})[this.event.id]),
        );
    }
}
